import { environment } from '../../environments/environment';
export class Settings {
  procteesperpage = 6;
  secondsperpage = environment.production ? 60 : 30;
  autoswitchpage = false;
  accesscode = "";
  filterby = "";
}
